module.exports = __webpack_public_path__ + "img/7_65.d960507d.png";